import './ccf-email-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfEmailIconProps extends SvgIconProps {
  fillColor?:string;
}

/**
 * CcfEmailIcon used to disply email icon in the contact card panel
 * @param props - CcfEmailIconProps
 * @example -- <CcfEmailIcon />
 */
export function CcfEmailIcon(props: CcfEmailIconProps) {
  return (
    <SvgIcon viewBox="0 0 15.809 11.066" fill={props?.fillColor} {...props} >
      <path className="a" d="M15.228,3.237A1.335,1.335,0,0,0,14.438,3H1.79A1.335,1.335,0,0,0,1,3.237L8.114,7.664Z" transform="translate(-0.21 -3)"/><path className="a" d="M15.809,5,8.3,9.664a3.423,3.423,0,0,1-.4.079.6.6,0,0,1-.4-.158L0,5H0v7.9a1.586,1.586,0,0,0,1.581,1.581H14.228A1.586,1.586,0,0,0,15.809,12.9V5Z" transform="translate(0 -3.419)"/>
    </SvgIcon>
  );
}

export default CcfEmailIcon;
